// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"d5b40ab9","235":"5547260d","374":"15f5af3d","836":"68b7db10"}[chunkId] + ".chunk.js";
};